import { AxiosResponse } from "axios";
import TreeBaseApi from "./TreeBaseApi";
import AxiosService from "./Axios";

const BASE_URL = "/device-group";

class DeviceGroupApi extends TreeBaseApi {

    constructor() {
        super(BASE_URL);
    }

    public async getGroupDeviceViews(groupId: string) {
        return AxiosService.get(BASE_URL + '/group-device-views', {
            params: {
                groupId: groupId
            }
        });
    }

    public async getDeviceTreeView(): Promise<AxiosResponse<any>> {
        return AxiosService.get(BASE_URL + '/device-tree-view');
    }

    public async addDevices(groupId: string, deviceIds: string[]): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + '/add-devices', {
            groupId: groupId,
            deviceIds: deviceIds
        });
    }

    public async removeDevices(groupId: string, deviceIds: string[]): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + '/remove-devices', {
            groupId: groupId,
            deviceIds: deviceIds
        });
    }

}

export default DeviceGroupApi;
